import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';
import { RoomStatusComponent } from './room-status.component';

@Component({
  selector: 'era-room-status-container',
  templateUrl: './room-status.container.html',
  imports: [RoomStatusComponent],
})
export class RoomStatusContainerComponent {
  private readonly store = inject(Store);

  public readonly room = this.store.selectSignal(selectCurrentRoom);
}
